import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { AlertsModalComponent } from './alerts-modal/alerts-modal.component';
import { AlertsComponent } from '@app/shared/components/alerts/alerts.component';

import { SharedModule } from '@app/shared/shared.module';
import { OpenAlertPopinDirective } from './directives/open-alert-popin.directive';
import { AlertProductPageModalComponent } from '@app/shared/components/alerts/alert-product-page-modal/alert-product-page-modal.component';
import { AlertService } from '@app/shared/components/alerts/services/alert.service';
import { FormsModule } from '@angular/forms';
import { FormSelectModule } from '@app/shared/components/form/components/form-select/form-select.module';
import { SvgModule } from '@app/shared/components/svg/svg.module';

@NgModule({
  imports: [CommonModule, MatDialogModule, SharedModule, FormsModule, FormSelectModule, SvgModule],
  exports: [AlertsComponent, AlertsModalComponent, AlertProductPageModalComponent, OpenAlertPopinDirective],
  declarations: [AlertsComponent, AlertsModalComponent, AlertProductPageModalComponent, OpenAlertPopinDirective],
  entryComponents: [AlertsModalComponent, AlertProductPageModalComponent],
  providers: [AlertService]
})
export class AlertsModule {}
